<script>
    import IconCross from '@/components/icon/IconCross.vue';
    import { releaseAndUnreleaseFile } from '@/api/file.js';

    export default {
        components: {
            IconCross: IconCross,
        },
        methods: {
            async unreleaseAllFile() {
                let fileListID = [];
                let fileList = this.$store.getters.IMAGES;
                fileList.forEach((fileValue, fileIndex) => {
                    if (fileValue.isActive === true) fileListID.push(fileValue.id);
                });

                if (fileListID.length > 0) {
                    const response = await releaseAndUnreleaseFile(
                        await this.$store.getters.ASSET_TYPE_IMAGES,
                        [], fileListID
                    );
                    if (response === true) {
                        fileList.forEach(async (fileValue, fileIndex) => {
                            await fileValue.setReleaseStatus(false);
                        });
                    }
                }
            }
        }
    }
</script>


<template>
    <button 
        class="left_button_main_container"
        @click="unreleaseAllFile"
    >
        <div class="left_button_icon_container">
            <IconCross 
                icon-height="16px"
                icon-width="16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Unrelease All</label>
        </div>
    </button>
</template>